import {
  LegalEmailLink,
  LegalList,
  LegalPageLayout,
  LegalParagraph,
  LegalSection,
} from '@/pages/legal/LegalPageLayout';

export default function TermsPage() {
  return (
    <LegalPageLayout
      version="Versão 2.0"
      updatedAt="Atualizado em 07/05/2026"
      title="Termos de Uso — Culture Monitor"
    >
      <LegalParagraph>
        Estes Termos de Uso regulam o acesso e a utilização do Culture Monitor, plataforma digital
        desenvolvida e operada pela <span className="italic">live.</span> (LIVE MARKETING DE
        DISSEMINACAO LTDA, inscrita no CNPJ sob nº 07.759.470/0001-82, com sede em Av. Brig. Faria
        Lima 1572 - Jardim Paulistano - CEP: 01451-917 - São Paulo / SP). Ao acessar ou utilizar a
        plataforma, você concorda integralmente com as condições descritas abaixo. Caso não
        concorde, não utilize os serviços. Recomendamos a leitura atenta também da nossa Política
        de Privacidade e Proteção de Dados Pessoais e da nossa Política de Cookies, que complementam
        estes Termos.
      </LegalParagraph>

      <LegalSection title="1. Definições">
        <LegalList
          className="list-none pl-0"
          items={[
            <>
              <strong>1.1. Plataforma:</strong> o ambiente digital Culture Monitor, disponibilizado
              pela <span className="italic">live.</span> por meio de acesso web ou outros canais
              autorizados.
            </>,
            <>
              <strong>1.2. Empresa Contratante:</strong> a pessoa jurídica que celebrou contrato com
              a <span className="italic">live.</span> para uso da plataforma.
            </>,
            <>
              <strong>1.3. Usuário:</strong> qualquer pessoa física que acesse a plataforma mediante
              credenciais fornecidas pela Empresa Contratante ou pela{' '}
              <span className="italic">live.</span>
            </>,
            <>
              <strong>1.4. Dados:</strong> informações inseridas, geradas ou coletadas no uso da
              plataforma, incluindo dados de comportamento de uso.
            </>,
            <>
              <strong>1.5. Dados Pessoais:</strong> informações relacionadas a pessoa natural
              identificada ou identificável, conforme definição da LGPD (Lei nº 13.709/2018).
            </>,
            <>
              <strong>1.6. LGPD:</strong> Lei Geral de Proteção de Dados Pessoais — Lei nº
              13.709/2018.
            </>,
            <>
              <strong>1.7. Operador / Subprocessador:</strong> terceiros contratados pela{' '}
              <span className="italic">live.</span> para apoiar a operação da plataforma (ex.:
              provedores de hospedagem, ferramentas de analytics, gestão de consentimento e
              parceiros de inteligência artificial), listados na Política de Privacidade.
            </>,
            <>
              <strong>1.8. Conteúdo da Plataforma:</strong> relatórios, insights, sinais culturais,
              metodologias, textos, imagens e demais materiais disponibilizados no Culture Monitor.
            </>,
          ]}
        />
      </LegalSection>

      <LegalSection title="2. Acesso e Cadastro">
        <LegalList
          className="list-none pl-0"
          items={[
            <>
              <strong>2.1.</strong> O acesso à plataforma é concedido mediante convite da Empresa
              Contratante. O usuário recebe um e-mail de ativação e deve concluir o cadastro
              definindo uma senha pessoal e intransferível.
            </>,
            <>
              <strong>2.2.</strong> O Usuário é integralmente responsável pela guarda e
              confidencialidade de suas credenciais de acesso. O compartilhamento de senha com
              terceiros é expressamente vedado.
            </>,
            <>
              <strong>2.3.</strong> A <span className="italic">live.</span> reserva-se o direito de
              suspender ou encerrar acessos em caso de uso indevido, violação destes Termos ou
              solicitação da Empresa Contratante.
            </>,
            <>
              <strong>2.4.</strong> O Usuário declara ter no mínimo 18 (dezoito) anos completos. A
              plataforma não é destinada a menores de idade e não coleta dados pessoais de crianças
              e adolescentes de forma intencional.
            </>,
            <>
              <strong>2.5.</strong> No primeiro acesso, o Usuário deverá manifestar de forma livre,
              informada e inequívoca o aceite a estes Termos e à Política de Privacidade. O
              consentimento para cookies analíticos e funcionais será coletado de forma separada e
              granular, nos termos da Política de Cookies.
            </>,
          ]}
        />
      </LegalSection>

      <LegalSection title="3. Uso Permitido">
        <LegalParagraph>
          <strong>3.1.</strong> A plataforma deve ser utilizada exclusivamente para as finalidades
          previstas no contrato firmado entre a <span className="italic">live.</span> e a Empresa
          Contratante.
        </LegalParagraph>
        <LegalParagraph>
          <strong>3.2.</strong> É vedado ao Usuário:
        </LegalParagraph>
        <LegalList
          className="list-none pl-0"
          items={[
            '(a) utilizar a plataforma para fins ilícitos ou contrários à ordem pública;',
            '(b) tentar acessar áreas restritas ou dados de outros usuários sem autorização;',
            <>
              (c) reproduzir, redistribuir ou comercializar qualquer conteúdo ou funcionalidade da
              plataforma sem autorização expressa da <span className="italic">live.</span>;
            </>,
            '(d) inserir dados falsos, maliciosos ou que violem direitos de terceiros;',
            '(e) realizar engenharia reversa, descompilar, desmontar ou tentar extrair o código-fonte ou os modelos de inteligência artificial subjacentes à plataforma;',
            <>
              (f) utilizar mecanismos automatizados (bots, crawlers, scrapers) para extrair dados ou
              conteúdos da plataforma sem autorização prévia e por escrito da{' '}
              <span className="italic">live.</span>;
            </>,
            '(g) utilizar o Conteúdo da Plataforma para treinar modelos de inteligência artificial de terceiros.',
          ]}
        />
      </LegalSection>

      <LegalSection title="4. Propriedade Intelectual">
        <LegalList
          className="list-none pl-0"
          items={[
            <>
              <strong>4.1.</strong> Todos os direitos relativos à plataforma Culture Monitor —
              incluindo código, design, marca, metodologias e conteúdos produzidos pela{' '}
              <span className="italic">live.</span> — são de propriedade exclusiva da{' '}
              <span className="italic">live.</span> e protegidos pela legislação de propriedade
              intelectual vigente.
            </>,
            <>
              <strong>4.2.</strong> O acesso à plataforma não transfere ao Usuário ou à Empresa
              Contratante qualquer direito de propriedade sobre esses ativos.
            </>,
            <>
              <strong>4.3.</strong> Sem prejuízo do disposto acima, a{' '}
              <span className="italic">live.</span> concede ao Usuário e à Empresa Contratante uma
              licença limitada, não exclusiva, intransferível e revogável para acesso e uso interno
              do Conteúdo da Plataforma, durante a vigência do contrato e exclusivamente para as
              finalidades nele previstas.
            </>,
            <>
              <strong>4.4.</strong> A reprodução parcial de trechos do Conteúdo da Plataforma em
              apresentações ou materiais internos da Empresa Contratante é permitida desde que
              mantida a atribuição expressa à <span className="italic">live.</span> e ao Culture
              Monitor, vedada a redistribuição pública sem autorização prévia e por escrito.
            </>,
          ]}
        />
      </LegalSection>

      <LegalSection title="5. Analytics, Cookies e Melhoria do Produto">
        <LegalList
          className="list-none pl-0"
          items={[
            <>
              <strong>5.1.</strong> A <span className="italic">live.</span> utiliza ferramentas de
              analytics próprias e de terceiros (incluindo, sem limitação, PostHog para mensuração
              de comportamento de uso e CookieYes para gestão de consentimento) dentro do ambiente
              logado para mensurar comportamento de uso, identificar pontos de fricção e aprimorar
              continuamente a experiência da plataforma.
            </>,
            <>
              <strong>5.2.</strong> A coleta de dados comportamentais via cookies analíticos e
              funcionais é realizada com base no consentimento livre, informado e granular do
              Usuário, coletado por meio do banner de consentimento (CookieYes) no primeiro acesso.
              O Usuário pode revisar, alterar ou revogar seu consentimento a qualquer tempo, sem
              prejuízo para o acesso às funcionalidades essenciais da plataforma.
            </>,
            <>
              <strong>5.3.</strong> Os dados coletados pelas ferramentas de analytics são utilizados
              exclusivamente para fins de melhoria do produto, mensuração de uso agregado e
              segurança da plataforma, e não são vendidos, cedidos a terceiros ou utilizados para
              fins publicitários.
            </>,
            <>
              <strong>5.4.</strong> A relação completa de cookies utilizados, suas finalidades e
              seus prazos de retenção está disponível na Política de Cookies, parte integrante
              destes Termos.
            </>,
          ]}
        />
        <LegalParagraph>
          Não compartilhamos informações de identificação pessoal publicamente ou com terceiros para
          fins comerciais ou publicitários, exceto quando exigido por lei ou mediante consentimento
          expresso do titular.
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="6. Privacidade e Proteção de Dados">
        <LegalList
          className="list-none pl-0"
          items={[
            <>
              <strong>6.1.</strong> O tratamento de dados pessoais na plataforma é regido pela
              Política de Privacidade e Proteção de Dados Pessoais da{' '}
              <span className="italic">live.</span>, em conformidade com a LGPD (Lei nº
              13.709/2018).
            </>,
            <>
              <strong>6.2.</strong> Para os fins da LGPD, a <span className="italic">live.</span>{' '}
              atua como Controladora dos dados pessoais dos Usuários da plataforma, e como Operadora
              em relação a eventuais dados pessoais que a Empresa Contratante venha a inserir ou
              compartilhar por meio da plataforma, observado o disposto no contrato comercial e em
              eventual Acordo de Tratamento de Dados (DPA) firmado entre as partes.
            </>,
            <>
              <strong>6.3.</strong> Para exercer seus direitos como titular de dados — acesso,
              correção, portabilidade ou eliminação — entre em contato pelo e-mail{' '}
              dpo@culturemonitor.com ou pelos canais indicados na
              Política de Privacidade.
            </>,
          ]}
        />
      </LegalSection>

      <LegalSection title="7. Segurança da Informação">
        <LegalList
          className="list-none pl-0"
          items={[
            <>
              <strong>7.1.</strong> A <span className="italic">live.</span> adota medidas técnicas
              e organizacionais razoáveis e proporcionais aos riscos para proteger a plataforma e os
              dados nela tratados, incluindo, no mínimo: criptografia em trânsito (TLS), controle de
              acesso por autenticação, monitoramento de acessos e processos de gestão de incidentes.
            </>,
            <>
              <strong>7.2.</strong> Em caso de incidente de segurança que possa acarretar risco ou
              dano relevante aos titulares, a <span className="italic">live.</span> notificará a
              Autoridade Nacional de Proteção de Dados (ANPD) e os titulares afetados em prazo
              razoável, conforme art. 48 da LGPD.
            </>,
            <>
              <strong>7.3.</strong> O Usuário compromete-se a comunicar imediatamente a{' '}
              <span className="italic">live.</span>, pelo e-mail{' '}
              dpo@culturemonitor.com, qualquer suspeita de uso não
              autorizado de suas credenciais ou de incidente de segurança envolvendo a plataforma.
            </>,
          ]}
        />
      </LegalSection>

      <LegalSection title="8. Disponibilidade e Atualizações">
        <LegalList
          className="list-none pl-0"
          items={[
            <>
              <strong>8.1.</strong> A <span className="italic">live.</span> envidará seus melhores
              esforços para manter a plataforma disponível de forma contínua, mas não garante
              disponibilidade ininterrupta. Eventuais níveis de serviço (SLA) e janelas de
              manutenção poderão ser definidos no contrato comercial firmado com a Empresa
              Contratante.
            </>,
            <>
              <strong>8.2.</strong> Manutenções programadas serão comunicadas com antecedência
              sempre que possível.
            </>,
            <>
              <strong>8.3.</strong> A <span className="italic">live.</span> pode atualizar
              funcionalidades, interface ou políticas da plataforma a qualquer tempo, notificando os
              usuários sobre alterações relevantes.
            </>,
          ]}
        />
      </LegalSection>

      <LegalSection title="9. Inteligência Artificial e Sistemas Automatizados">
        <LegalList
          className="list-none pl-0"
          items={[
            <>
              <strong>9.1.</strong> O Culture Monitor pode utilizar sistemas de inteligência
              artificial e processamento automatizado para apoiar a geração de insights, classificação
              de sinais culturais e organização de conteúdos.
            </>,
            <>
              <strong>9.2.</strong> Os outputs gerados por IA são fornecidos como apoio analítico e
              não substituem julgamento humano, decisões estratégicas ou aconselhamento profissional.
              A <span className="italic">live.</span> não garante exatidão absoluta, completude ou
              ausência de vieses nos resultados gerados por IA, e o Usuário e a Empresa Contratante
              reconhecem e aceitam essa limitação.
            </>,
            <>
              <strong>9.3.</strong> Caso a <span className="italic">live.</span> venha a adotar
              decisões automatizadas que afetem direitos do Usuário, será assegurado o direito de
              solicitar revisão humana, nos termos do art. 20 da LGPD.
            </>,
            <>
              <strong>9.4.</strong> É vedada a utilização do Conteúdo da Plataforma como input para
              treinamento de modelos de inteligência artificial de terceiros sem autorização prévia e
              expressa da <span className="italic">live.</span>
            </>,
          ]}
        />
      </LegalSection>

      <LegalSection title="10. Confidencialidade">
        <LegalList
          className="list-none pl-0"
          items={[
            <>
              <strong>10.1.</strong> As partes reconhecem que, no curso do uso da plataforma, poderão
              ter acesso a informações confidenciais da outra parte, incluindo, sem limitação,
              metodologias, dados estratégicos, insights culturais, dados comerciais e informações
              técnicas.
            </>,
            <>
              <strong>10.2.</strong> Cada parte compromete-se a manter sigilo sobre tais
              informações, utilizando-as exclusivamente para os fins previstos no contrato e nestes
              Termos, e a não divulgá-las a terceiros sem autorização prévia e por escrito da outra
              parte, salvo por exigência legal ou ordem judicial.
            </>,
            <>
              <strong>10.3.</strong> A obrigação de confidencialidade permanece em vigor pelo prazo
              de 5 (cinco) anos após o término do contrato.
            </>,
          ]}
        />
      </LegalSection>

      <LegalSection title="11. Limitação de Responsabilidade">
        <LegalList
          className="list-none pl-0"
          items={[
            <>
              <strong>11.1.</strong> A <span className="italic">live.</span> não se responsabiliza
              por danos decorrentes de: uso indevido da plataforma pelo Usuário; falhas em
              dispositivos, conexões ou sistemas de terceiros; ou eventos de força maior.
            </>,
            <>
              <strong>11.2.</strong> A responsabilidade da <span className="italic">live.</span>{' '}
              perante o Usuário fica limitada ao valor contratualmente acordado com a Empresa
              Contratante, nos termos da legislação aplicável, ressalvadas as hipóteses de dolo,
              culpa grave e descumprimento das obrigações decorrentes da LGPD, que se sujeitam ao
              regime legal específico.
            </>,
            <>
              <strong>11.3.</strong> Em nenhuma hipótese a <span className="italic">live.</span>{' '}
              responderá por lucros cessantes, perda de oportunidade de negócio ou danos indiretos
              decorrentes de decisões tomadas pelo Usuário ou pela Empresa Contratante com base em
              insights gerados pela plataforma.
            </>,
          ]}
        />
      </LegalSection>

      <LegalSection title="12. Encerramento e Portabilidade de Dados">
        <LegalList
          className="list-none pl-0"
          items={[
            <>
              <strong>12.1.</strong> Com o encerramento do contrato com a Empresa Contratante, os
              acessos dos usuários vinculados serão desativados.
            </>,
            <>
              <strong>12.2.</strong> A Empresa Contratante poderá solicitar, em até 30 dias após o
              encerramento, a exportação de dados em formatos estruturados (CSV, JSON ou
              equivalente) pelo e-mail dpo@culturemonitor.com,
              incluindo: (a) lista de usuários ativos e inativos com nomes, e-mails e datas de
              cadastro; (b) métricas de uso agregadas e anonimizadas.
            </>,
            <>
              <strong>12.2.1.</strong> Não estão incluídos na portabilidade: (i) Conteúdo da
              Plataforma (relatórios, insights, metodologias de propriedade da live.); (ii) dados
              pessoais identificáveis individualmente (regidos pelo art. 18, V, da LGPD); e (iii)
              logs técnicos e de segurança.
            </>,
            <>
              <strong>12.2.2.</strong> A exportação será entregue em até 15 dias úteis após
              solicitação formal.
            </>,
            <>
              <strong>12.3.</strong> Após o prazo indicado, os dados pessoais serão eliminados ou
              anonimizados, salvo quando a retenção for exigida por lei.
            </>,
          ]}
        />
      </LegalSection>

      <LegalSection title="13. Alterações nos Termos">
        <LegalParagraph>
          <strong>13.1.</strong> Estes Termos podem ser revisados periodicamente. Alterações
          materiais serão comunicadas por e-mail ou aviso na plataforma com antecedência mínima de
          15 dias antes de entrarem em vigor. O uso continuado da plataforma após as alterações
          implica aceitação das novas condições.
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="14. Foro e Lei Aplicável">
        <LegalParagraph>
          <strong>14.1.</strong> Estes Termos são regidos pelas leis da República Federativa do
          Brasil. Fica eleito o foro da Comarca de São Paulo/SP para dirimir quaisquer
          controvérsias.
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="15. Contato">
        <LegalParagraph>
          Dúvidas ou solicitações relacionadas a estes Termos devem ser encaminhadas para{' '}
          <LegalEmailLink email="dpo@culturemonitor.com" />.
        </LegalParagraph>
        <LegalList
          items={[
            <>
              <strong>Encarregado de Dados (DPO):</strong> Lucas Polato —{' '}
              <LegalEmailLink email="dpo@culturemonitor.com" />
            </>,
          ]}
        />
      </LegalSection>
    </LegalPageLayout>
  );
}
